import { onBeforeUnmount, ref } from "vue";

// Ширина телефона (тот же порог, что md: у Tailwind). Где matchMedia нет
// (тесты), считаем телефоном.
const PHONE_QUERY = "(max-width: 767.98px)";

export function useIsPhone() {
  const mql = typeof window !== "undefined" && window.matchMedia ? window.matchMedia(PHONE_QUERY) : null;
  const isPhone = ref(mql ? mql.matches : true);
  const onChange = (e: MediaQueryListEvent) => (isPhone.value = e.matches);
  mql?.addEventListener?.("change", onChange);
  onBeforeUnmount(() => mql?.removeEventListener?.("change", onChange));
  return isPhone;
}
